import { expandJsonSize, REVERSE_STATE_JSON_MAPPING } from "shared/src/libs/oauthLib/compressJson"
import { refreshAraAccessToken } from "shared/src/libs/signatureLib/refreshLib"
import { parseJwt } from "shared/src/libs/signatureLib/signatureLib"
import { useMountEffect } from "shared/src/libs/hooksLib/hooksLib"

import { getOAuthStatus } from "shared/src/libs/apiLib/apiLib"
import { capitalize } from "shared/src/libs/stringLib/stringLib"
import { CenteredStatus } from "shared/src/components/CenteredStatus/CenteredStatus"

export function OAuthCallback() {
	const query = new URLSearchParams(window.location.search)

	const parent = window.parent
	const rawState = query.get("state")
	const state = rawState ? expandJsonSize(rawState, REVERSE_STATE_JSON_MAPPING) : ""
	const { newTab, integrationData, sig, shortId, clientId, codeVerifierId } = state

	useMountEffect(async () => {
		let accessToken
		if (sig == null && shortId != null) {
			//get sig from shortId
			;({ accessToken } = await refreshAraAccessToken(shortId))
		}
		// new tab flow
		console.log("sending ready message to oauth channel")
		const authOverride = accessToken ?? sig
		let claims
		if (authOverride != null) {
			claims = { ...parseJwt(authOverride), ...integrationData }
		} else {
			claims = integrationData
		}

		getOAuthStatus(
			{
				authCode: query.get("x-code"),
				codeVerifierId,
				platform: claims.platform,
				externalUserId: claims.userId,
				externalClientId: claims.externalClientId,
				clientId: clientId ?? claims.clientId ?? claims["custom:companyId"],
			},
			authOverride
		)
			.then((response) => {
				if (response) {
					// success, close the window
					if (newTab) {
						window.close()
					} else {
						parent?.postMessage({ query: Object.fromEntries(query.entries()) }, window.location.origin)
					}
				} else {
					throw new Error("Error authorizing HireAra, false value returned from api")
				}
			})
			.catch((e) => {
				console.error(e)
				alert(`Error authorizing Hireara access to ${capitalize(claims.platform)}`)
			})
	})

	return <CenteredStatus isLoading={true}>Authenticating</CenteredStatus>
}
